import React from "react";
import contextProvider from "../../contextProvider";

import _ReactOBaseComponent, { withDefinedContext } from "../_ReactOBaseComponent";

const context_exposed_methods = ["open", "close", "toggle"];

class _LayoutFixedBody extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      opened: false,
    };
    super(props, initState);
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {}

  onComponentWillUnmount() {}

  close() {
    this.setState({ opened: false });
  }

  open() {
    this.setState({ opened: true });
  }

  toggle() {
    this.setState({ opened: !this.state.opened });
  }

  onRender() {
    /*
			<div		// Fix - per Window Edge
					style={{
						marginBottom: this.context._LayoutPage.getSafeBoundaries().top + 'px',
						height: '100%'
					}}
				>
			</div>
		*/
    return (
      <div
        className="_layout-fixed-body"
        style={{
          top: this.state.opened ? "0%" : "-100%",
          marginTop: this.context._LayoutPage.getSafeBoundaries().top + "px",
          left: "0px",
          paddingBottom: this.context._LayoutPage.getSafeBoundaries().top + "px",
        }}
      >
        {React.Children.map(this.props.children, (_C_child, _C_idx) => {
          return _C_child ? React.cloneElement(_C_child, {}) : null;
        })}
      </div>
    );
  }
}

export default contextProvider(
  withDefinedContext(_LayoutFixedBody, "_LayoutFixedBody", context_exposed_methods),
  {
    retrieve: ["_LayoutPage"],
  }
);
